import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import cn from 'classnames';
import { useDevice } from '../../providers/Device';
import { useIsInBottomSheet } from '../../providers/IsInBottomSheetProvider';
import { useBiAction } from '../BiTracking';
import { FullRow } from '../Layout';
import { Typography } from '../Typography';
import styles from './Card.module.scss';
export function Card(props) {
    const { className, padding, verticalPadding, autoHeight, title, children, disableSeparator, actions, skin = 'default', as, highlightOnHover, testId, borderRadius = 's', borderSkin, shadow = 'default', disabled = false, isMobile, bi, noBi: _noBi } = props, rest = _object_without_properties(props, [
        "className",
        "padding",
        "verticalPadding",
        "autoHeight",
        "title",
        "children",
        "disableSeparator",
        "actions",
        "skin",
        "as",
        "highlightOnHover",
        "testId",
        "borderRadius",
        "borderSkin",
        "shadow",
        "disabled",
        "isMobile",
        "bi",
        "noBi"
    ]);
    const logBiAction = useBiAction();
    const { isMobileDevice } = useDevice();
    const isInBottomSheet = useIsInBottomSheet();
    const effectiveIsMobileDevice = isMobile !== null && isMobile !== void 0 ? isMobile : isMobileDevice || isInBottomSheet;
    const Component = as || 'div';
    const handleClick = (e)=>{
        if (as === 'button' && (bi === null || bi === void 0 ? void 0 : bi.name)) {
            logBiAction({
                entityType: 'card',
                entityName: bi.name,
                actionType: 'click',
                testId: testId !== null && testId !== void 0 ? testId : '',
                data: bi.data
            });
        }
        if (!disabled) {
            var _rest_onClick;
            (_rest_onClick = rest.onClick) === null || _rest_onClick === void 0 ? void 0 : _rest_onClick.call(rest, e);
        }
    };
    return /*#__PURE__*/ _jsxs(Component, _object_spread_props(_object_spread(_object_spread_props(_object_spread({}, rest), {
        onClick: handleClick
    }), disabled ? {
        'aria-disabled': true
    } : {}, testId != null ? {
        'data-testid': testId
    } : {}), {
        className: cn(styles.root, [
            styles[skin + 'Skin']
        ], {
            [styles[padding + 'Padding']]: !!padding,
            [styles[verticalPadding + 'VerticalPadding']]: !!verticalPadding,
            [styles.autoHeight]: autoHeight,
            [styles.highlightOnHover]: highlightOnHover && !disabled,
            [styles.disabled]: disabled,
            [styles[borderRadius + 'BorderRadius']]: !!borderRadius,
            [styles[borderSkin + 'BorderSkin']]: !!borderSkin,
            [styles.noShadow]: shadow === 'none'
        }, className),
        children: [
            title && /*#__PURE__*/ _jsxs("div", {
                className: styles.titleRow,
                children: [
                    /*#__PURE__*/ _jsx(Typography, {
                        weight: "normal",
                        variant: "h5",
                        children: title
                    }),
                    actions && !effectiveIsMobileDevice && /*#__PURE__*/ _jsx("div", {
                        className: styles.actions,
                        children: actions
                    })
                ]
            }),
            title && !disableSeparator && /*#__PURE__*/ _jsx(Separator, {}),
            children,
            title && actions && effectiveIsMobileDevice && /*#__PURE__*/ _jsx(FullRow, {
                gap: 8,
                alignItems: "center",
                justifyContent: "start",
                wrap: true,
                testId: testId != null ? "".concat(testId, "-action-row") : undefined,
                className: styles.actionRow,
                children: actions
            })
        ]
    }));
}
const Separator = ()=>/*#__PURE__*/ _jsx("div", {
        style: {
            width: '100%',
            minHeight: '1px',
            backgroundColor: 'var(--grey-semi)'
        }
    });
